import { getStaffAuditAccuracyQuality } from "./staff-audit-log-presentation-helper";


const roundMeters = (value) => Number(value.toFixed(1));
const formatDistance = (value) => value >= 1000 ?
    `${ roundMeters(value / 1000) } km` : `${ roundMeters(value) } m`;
const hasHistoricalZone = (zone) => (
    Number.isFinite(zone?.latitude) && Math.abs(zone.latitude) <= 90 &&
    Number.isFinite(zone?.longitude) && Math.abs(zone.longitude) <= 180 &&
    Number.isFinite(zone?.radius) && zone.radius > 0
);

const getScenario = (scan, zone) => {
    const quality = getStaffAuditAccuracyQuality(scan?.accuracy);

    if (quality === "unknown")
    {
        return { scenario: "missing_accuracy" };
    }

    if (!hasHistoricalZone(zone))
    {
        return { scenario: "missing_zone" };
    }

    const distance = scan.distance_from_zone;

    if (!Number.isFinite(distance) || distance < 0)
    {
        return { scenario: "missing_distance" };
    }

    const accuracy = scan.accuracy;
    const radius = zone.radius;

    if (distance - accuracy > radius)
    {
        return { scenario: "outside", values: { distance: formatDistance(distance) } };
    }

    if (distance + accuracy <= radius)
    {
        return { scenario: "inside" };
    }

    if (quality === "poor")
    {
        return {
            scenario: "imprecise",
            fact: accuracy > radius ? "imprecise_exceeds_zone" : "imprecise",
            values: { accuracy: roundMeters(accuracy) },
        };
    }

    const outside = distance - radius;

    return outside > 0 ? {
        scenario: "boundary",
        fact: outside < 0.1 ? "boundary_outside_small" : "boundary_outside",
        values: { outside: roundMeters(outside), accuracy: roundMeters(accuracy) },
    } : {
        scenario: "boundary",
        fact: "boundary_inside",
    };
};

const WORKER_ACTIONS = {
    boundary: "retry_center",
    imprecise: "retry_entrance",
    outside: "verify_location",
};

export const getStaffScanLocationGuidance = ({ scan, zone } = {}) => {
    const { scenario, fact = scenario, values = {} } = getScenario(scan, zone);
    const action = scan?.status === "success" ? "accepted" :
        scan?.status === "rejected" && scan.reason === "OUTSIDE_RADIUS" ?
            WORKER_ACTIONS[ scenario ] || "check_log" : "check_log";

    return {
        scenario,
        fact,
        values,
        action,
        audience: action === "accepted" || action === "check_log" ? "manager" : "worker",
    };
};
